<ion-content class="ion-padding">
  <ion-refresher slot="fixed" (ionRefresh)="carregarCadastro($event)">
    <ion-refresher-content>
    </ion-refresher-content>
  </ion-refresher>

  <section class="comprovante-renda-assinatura">
    <usucampeao-header [title]="titulos[tipo]"></usucampeao-header>

    <ng-container *ngIf="!contratoExpirado">
      <ng-container [ngSwitch]="tipo">
        <div class="comprovante-renda-assinatura">
          <ion-text class="font-text font-text--medium">
            <p>Tire uma foto ou suba o arquivo de imagem do comprovante de renda assinado.</p>
          </ion-text>
        
        
          <ion-text class="text-link" (click)="abrirModalComprovanteRenda()">
            Visualizar e imprimir comprovante de renda
          </ion-text>
        
          <div class="comprovante-renda-assinatura__actions">
            <ion-button class="ion-margin-bottom" mode="md" (click)="irParaUpload()">
              Tirar ou subir Foto do Comprovante
            </ion-button>
        
            <ion-button id="contrato-alterar-metodo-assinatura" mode="md" fill="outline" (click)="alterarMetodoAssinatura()">
              Alterar método de validação
            </ion-button>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </section>
</ion-content>
